import { render } from "./TemplateCard.vue?vue&type=template&id=bd0d1c8e&scoped=true"
import script from "./TemplateCard.vue?vue&type=script&lang=js"
export * from "./TemplateCard.vue?vue&type=script&lang=js"

import "./TemplateCard.vue?vue&type=style&index=0&id=bd0d1c8e&lang=less&scoped=true"

import exportComponent from "F:\\workspace\\clientapps\\Advertising-Platform\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd0d1c8e"]])

export default __exports__